<template>
  <div class="home-box">
    <LayoutHeader></LayoutHeader>
    <div class="layout-content">
      <div class="backdrop-layer">
        <img src="../../assets/bg-1.fw.png" height="1011" width="402"/>
        <img src="../../assets/bg-3.fw.png" height="593" width="776" style="margin-top: 13%;"/>
        <img src="../../assets/bg-2.fw.png" height="1011" width="402"/>
      </div>
      <div class="home-left">
        <div class="moule-box he20 no-bg opt-sp">
          <LeftModuleOne :clienttotal="clienttotal" :totalcapacity="totalcapacity"></LeftModuleOne>
        </div>
        <div class="moule-box he40">
          <router-link to="/sentiment?id=5" target="_blank" title="点击查看分析"><p class="moule-title"><span class="title-name">行业监测</span></p></router-link>
          <LeftModuleTwos :dataRefresh="dataRefresh"></LeftModuleTwos>
        </div>
        <div class="moule-box he40">
          <router-link to="/risefall" target="_blank" title="点击查看分析"><p class="moule-title"><span class="title-name">化纤涨跌榜</span></p></router-link>
          <LeftModuleFour :dataRefresh="dataRefresh"></LeftModuleFour>
        </div>
      </div>
      <div class="home-center">
        <CenterTop :dataRefresh="dataRefresh" @totalcapacity="gettotalcapacity"></CenterTop>
        <div style="position: relative; width: 800px; height: 567px; margin: 0 auto; margin-top: 1.5%"><CenterContent></CenterContent></div>
        <div class="new-block">
          <a class="transform-show" :class='times==index?"transform-show-on":""' v-for="(itme,index) in datas" :key="index" :href="'/newdetail?id='+itme.id" target="_blank">
            <span>产业信息：</span><p class="new-block-c">{{ itme.title }}</p>
          </a>
        </div>
      </div>
      <div class="home-right">
        <div class="moule-box he20 opt-sp" style="margin-top: -30px;margin-bottom: 5px;transform: scale(90%) translate(-1%, 5%)">
<!--          <RightModule></RightModule>-->
          <p class="moule-title" title="点击查看分析" @click="hanle('/matching')"><span class="title-name">撮合交易</span></p>
          <RightModuleFour :dataRefresh="dataRefresh"></RightModuleFour>
        </div>
        <div class="moule-box he40">
          <p class="moule-title" title="点击查看分析" @click="hanle('/Printingdyeing')"><span class="title-name">数智印染</span></p>
          <RightModuleFive :dataRefresh="dataRefresh"></RightModuleFive>
        </div>
        <div class="moule-box he40">
          <router-link to="/pallet" target="_blank" title="点击查看总览"><p class="moule-title"><span class="title-name">共享托盘</span></p></router-link>
          <RightModulePallet @clienttotal="getclienttotal" :dataRefresh="dataRefresh"></RightModulePallet>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftModuleTwo from './module/left-module-two'
import LeftModuleTwos from './module/left-module-two2'
import LeftModuleOne from './module/left-module-one'
import LeftModuleThree from './module/left-module-three'
import LeftModuleFour from './module/left-module-four'
import CenterTop from './module/center-top'
import CenterContent from './module/center-content'
import RightModule from './module/right-module-one'
import RightModuleTwo from './module/right-module-two'
import RightModuleThree from './module/right-module-three'
import RightModuleFour from './module/right-module-four'
import RightModuleFive from './module/right-module-five'
import RightModulePallet from './module/right-module-pallet'
import LayoutHeader from '../layout/layout-header'
import myStorage from '../../bll/utils';
export default {
  name: 'HomePage',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LeftModuleOne,
    LeftModuleTwo,
    LeftModuleTwos,
    LeftModuleThree,
    CenterTop,
    CenterContent,
    RightModule,
    RightModuleTwo,
    RightModuleThree,
    LayoutHeader,
    RightModulePallet,
    RightModuleFour,
    RightModuleFive,
    LeftModuleFour
  },
  data () {
    return {
      times:0,
      clienttotal:0,
      totalcapacity:0,
      datas:[
        {name:'华瑞信息资深分析师受邀在『化纤行业“高质量发展”实务能力培训班』做主题分享！',types:'行业资讯',url:'/newdetail?id=15'},
        {name:'1、安置自主择业军转干部人数占企业总人数60%以上的新办企业，经批准，3年内免征营业税和企业所得税。',types:'惠企政策',url:'/newdetail?id=1'},
        {name:'区委书记张冲林赴杭州招商引资',types:'招商引资',url:'/newdetail?id=2'},
        {name:'为绿色低碳企业腾飞插上翅膀',types:'行业资讯',url:'/newdetail?id=3'},
        {name:'《信息化建设》|“浙”样加快推进“未来工厂”建设',types:'行业资讯',url:'/newdetail?id=4'},
        {name:'袁家军：唯实惟先 整体提升 加快打造数字变革高地',types:'行业资讯',url:'/newdetail?id=5'},
        {name:'浙江省2022年数字工厂标杆企业认定类和培育类名单公布',types:'行业资讯',url:'/newdetail?id=6'},
        {name:'探访绿色纤维领域的“小巨人”企业--汇隆新材',types:'行业资讯',url:'/newdetail?id=7'},
        {name:'聚焦深化数字政府建设，浙江召开专场发布会',types:'行业资讯',url:'/newdetail?id=8'},
        {name:'萧山率先推进产业数字化“三个全覆盖”，发布《萧山区制造业细分行业中小企业数字化改造扩面推进方案（2022-2024）》',types:'行业资讯',url:'/newdetail?id=14'}
      ]
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted () {
    let $this=this
    const url = '/api-portal/article/articleList';
    this.$api.post(url, {title:'',pageNum:1,pageSize:20}, (response) => {
      let datas=response.data||''
      if(datas.data){
        this.datas=datas.data.records
      }
      this.cutnew()
    },'json');
  },
  methods: {
    hanle(url) {
      let info=myStorage.getItem('localStorage','userinfo')
      if(info){
        // const infoname=info.zhnc
        // if((process.env.ACCESSP).indexOf(infoname)>=0){
          let routeData = this.$router.resolve({path: url})
          window.open(routeData.location.hash || routeData.location.path, "_blank")
        // }else {
        //   this.$message({
        //     type: 'warning',
        //     duration:5000,
        //     message: '该功能需要访问权限才能进入，请联系管理员！'
        //   })
        // }
      }else {
        this.$message({
          type: 'warning',
          duration:5000,
          message: '您还未登录或登录已失效，不可以访问其他功能！'
        })
      }
    },
    cutnew(){
      let $this=this;
      let tt=$this.times
      let h=$this.datas.length
      if(h>1){
        setInterval(function (){
          if(tt>=h-1){
            tt = -1
          }
          tt+=1
          $this.times=tt
        },4000)
      }

    },
    getclienttotal(num){
      this.clienttotal=num
    },
    gettotalcapacity(num){
      this.totalcapacity=7523
    }
  }
}
</script>

<style scoped>
.layout-content {
  position: absolute;
  top: 120px;
  width: 100%;
  height: calc(100% - 120px);
  left: 0;
}
.home-box {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 11;
  -moz-user-select:none; /* Firefox私有属性 */
  -webkit-user-select:none; /* WebKit内核私有属性 */
  -ms-user-select:none; /* IE私有属性(IE10及以后) */
  -khtml-user-select:none; /* KHTML内核私有属性 */
  -o-user-select:none; /* Opera私有属性 */
  user-select:none; /* CSS3属性 */
}
.home-left,.home-right {
  position: absolute;
  width: 526px;
  top: 0;
  height: calc(100% - 20px);
  padding: 10px;
}
.home-left {
  left: 0;
}
.home-right {
  right: 0;
}
.home-center {
  width: 50%;
  position: absolute;
  left: 25%;
  top: 0;
  height: 100%;
}
.moule-box {
  width: 100%;
  height: calc(33.33% - 45px);
  position: relative;
  margin: 25px 0 0;
  z-index: 24;
}
.home-left .moule-box {
  background: url("../../assets/sj_bj_l2.fw.png");
  background-size: 100% 100%;
}
.home-right .moule-box {
  background: url("../../assets/sj_bj_r2.fw.png");
  background-size: 100% 100%;
}
.home-right .moule-box.no-bg,.home-left .moule-box.no-bg {
  background: none;
}
.moule-title {
  position: absolute;
  top: -15px;
  font-size: 17px;
  padding: 12px 37px;
  background: url("../../assets/bt-bg.fw.png");
  left: 35px;
  background-size: 100% 100%;
  font-family: 'fzskjt';
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  z-index: 2;
}

.moule-title:hover{
  text-decoration: underline;
}

.title-name {
  color: #2487FF;
  background: -webkit-linear-gradient(90deg, #2487FF,#fff,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.he20 {
  height: 15%;
}
.he40{
  height: 35%;
}
.opt-sp {
  margin: -35px 0 0 0;
  height: 28%;
}

.backdrop-layer{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content:space-between;
  align-items:center;
  background: url("../../assets/bg-4.fw.png") no-repeat center/100%;
}

.new-block{
  width: 810px;
  height: 53px;
  border: 1px solid #2F86F0;
  background: rgba(0,45,134,.84);
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -405px;
  z-index: 23;
  color: #fff;
  font-size: 15px;
  font-family: 微软雅黑;
  overflow: hidden;
}

.new-block span{
  font-size: 18px;
}

.new-block-c{
  overflow: hidden;
  width: 680px;
  height: 29px;
  line-height: 29px;
  padding: 5px;
  background: #001031;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.transform-show{
  position: absolute;
  color: #fff;
  padding: 0px 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 1s;
  z-index: 1;
  opacity: 0;
  display: flex;
  align-items:center;
  transform: translate(0,-100%);
  text-decoration: none;
}

.transform-show-on{
  opacity: 1;
  transform: translate(0%,0%);
}

</style>



// WEBPACK FOOTER //
// src/views/HomeManage/home-index.vue